"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete a basket item in a given basket
     * Delete a basket item in a given basket
     */
    DefaultApi.prototype.deleteBasketItemV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/basketaddons",
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.DeleteBasketaddonsRequestToJSON)(requestParameters.deleteBasketaddonsRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ResponseDeleteBasketAddOnsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete a basket item in a given basket
     * Delete a basket item in a given basket
     */
    DefaultApi.prototype.deleteBasketItemV2 = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteBasketItemV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get add-on products from a specific basket ID
     * Get add-ons
     */
    DefaultApi.prototype.getBasketaddonsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.basketId === null || requestParameters.basketId === undefined) {
                            throw new runtime.RequiredError('basketId', 'Required parameter requestParameters.basketId was null or undefined when calling getBasketaddons.');
                        }
                        queryParameters = {};
                        if (requestParameters.basketId !== undefined) {
                            queryParameters['basketId'] = requestParameters.basketId;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/basketaddons",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ResponseGetBasketAddOnsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get add-on products from a specific basket ID
     * Get add-ons
     */
    DefaultApi.prototype.getBasketaddons = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBasketaddonsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get mocked baskedID for testing purpose
     * Get mocked baskedID
     */
    DefaultApi.prototype.getMockbasketRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/mockbasket",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ResponseGetMockedBasketFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get mocked baskedID for testing purpose
     * Get mocked baskedID
     */
    DefaultApi.prototype.getMockbasket = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMockbasketRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get relevant offers from TopK for a specific basket ID
     * Get Offers
     */
    DefaultApi.prototype.getOffersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.basketId === null || requestParameters.basketId === undefined) {
                            throw new runtime.RequiredError('basketId', 'Required parameter requestParameters.basketId was null or undefined when calling getOffers.');
                        }
                        if (requestParameters.ipCountry === null || requestParameters.ipCountry === undefined) {
                            throw new runtime.RequiredError('ipCountry', 'Required parameter requestParameters.ipCountry was null or undefined when calling getOffers.');
                        }
                        if (requestParameters.currency === null || requestParameters.currency === undefined) {
                            throw new runtime.RequiredError('currency', 'Required parameter requestParameters.currency was null or undefined when calling getOffers.');
                        }
                        if (requestParameters.language === null || requestParameters.language === undefined) {
                            throw new runtime.RequiredError('language', 'Required parameter requestParameters.language was null or undefined when calling getOffers.');
                        }
                        queryParameters = {};
                        if (requestParameters.basketId !== undefined) {
                            queryParameters['basketId'] = requestParameters.basketId;
                        }
                        if (requestParameters.ipCountry !== undefined) {
                            queryParameters['ipCountry'] = requestParameters.ipCountry;
                        }
                        if (requestParameters.currency !== undefined) {
                            queryParameters['currency'] = requestParameters.currency;
                        }
                        if (requestParameters.language !== undefined) {
                            queryParameters['language'] = requestParameters.language;
                        }
                        if (requestParameters.affiliateId !== undefined) {
                            queryParameters['affiliateId'] = requestParameters.affiliateId;
                        }
                        if (requestParameters.platform !== undefined) {
                            queryParameters['platform'] = requestParameters.platform;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pointOfSale !== undefined) {
                            queryParameters['pointOfSale'] = requestParameters.pointOfSale;
                        }
                        if (requestParameters.mock !== undefined) {
                            queryParameters['mock'] = requestParameters.mock;
                        }
                        headerParameters = {};
                        if (requestParameters.xBookingExperimentState !== undefined && requestParameters.xBookingExperimentState !== null) {
                            headerParameters['x-booking-experiment-state'] = String(requestParameters.xBookingExperimentState);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v1/offers",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ResponseGetOffersFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get relevant offers from TopK for a specific basket ID
     * Get Offers
     */
    DefaultApi.prototype.getOffers = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOffersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get add-on products from a specific order ID
     * Get add-ons
     */
    DefaultApi.prototype.getOrderaddonsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.anchorProduct === null || requestParameters.anchorProduct === undefined) {
                            throw new runtime.RequiredError('anchorProduct', 'Required parameter requestParameters.anchorProduct was null or undefined when calling getOrderaddons.');
                        }
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling getOrderaddons.');
                        }
                        queryParameters = {};
                        if (requestParameters.anchorProduct !== undefined) {
                            queryParameters['anchorProduct'] = requestParameters.anchorProduct;
                        }
                        if (requestParameters.orderId !== undefined) {
                            queryParameters['orderId'] = requestParameters.orderId;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/orderaddons",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ResponseGetOrderAddOnsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get add-on products from a specific order ID
     * Get add-ons
     */
    DefaultApi.prototype.getOrderaddons = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrderaddonsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.healthGetRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/health",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.healthGet = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.healthGetRaw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Save add-on product to a specific basket ID
     * Post add-ons
     */
    DefaultApi.prototype.postBasketaddonsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/basketaddons",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.PostBasketaddonsRequestToJSON)(requestParameters.postBasketaddonsRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ResponseGetBasketAddOnsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Save add-on product to a specific basket ID
     * Post add-ons
     */
    DefaultApi.prototype.postBasketaddons = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postBasketaddonsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create order request for specific basket ID
     * Post create order
     */
    DefaultApi.prototype.postOrdercreaterequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/ordercreaterequest",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.PostOrderCreateRequestToJSON)(requestParameters.postOrderCreateRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ResponsePostOrderCreateRequestFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create order request for specific basket ID
     * Post create order
     */
    DefaultApi.prototype.postOrdercreaterequest = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postOrdercreaterequestRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.readyGetRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/ready",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.readyGet = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readyGetRaw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DefaultApi;
}(runtime.BaseAPI));
exports.DefaultApi = DefaultApi;
